module.exports = __webpack_public_path__ + "media/images/athletes/1856-7d14e255d076ad2b6ea209b3a951b16b.png";